import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title: string;
    description?: string;
    image?: string;
    url?: string;
    type?: 'website' | 'article';
    keywords?: string[];
    author?: string;
}

const DEFAULT_DESCRIPTION = 'Unlock your visual thinking with NoteSpace. The infinite whiteboard for spatial organization, real-time collaboration, and AI-powered study tools.';
const DEFAULT_IMAGE = 'https://www.notesscape.in/og-image.png';
const SITE_NAME = 'NoteSpace';
const TWITTER_HANDLE = '@notescape_app'; // Replace with actual handle if available, or remove

export const SEO: React.FC<SEOProps> = ({
    title,
    description = DEFAULT_DESCRIPTION,
    image = DEFAULT_IMAGE,
    url,
    type = 'website',
    keywords = [],
    author = 'NoteSpace',
}) => {
    const siteTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
    const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : '');

    return (
        <Helmet>
            {/* Basic Metadata */}
            <title>{siteTitle}</title>
            <meta name="description" content={description} />
            <meta name="author" content={author} />
            {keywords.length > 0 && <meta name="keywords" content={keywords.join(', ')} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={currentUrl} />
            <meta property="og:title" content={siteTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content={SITE_NAME} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content={TWITTER_HANDLE} />
            <meta name="twitter:creator" content={TWITTER_HANDLE} />
            <meta name="twitter:url" content={currentUrl} />
            <meta name="twitter:title" content={siteTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Canonical URL */}
            {currentUrl && <link rel="canonical" href={currentUrl} />}
        </Helmet>
    );
};
